export type DeviceStatus = 'APPROVED' | 'PENDING' | 'REJECTED';

export function computeDeviceStatus(device: {
  approvedIps: string[];
  pendingIps: string[];
  rejectedIps: string[];
}): DeviceStatus {
  if (device.approvedIps.length > 0) return 'APPROVED';
  if (device.pendingIps.length > 0) return 'PENDING';
  return 'REJECTED';
}
